import { z } from "zod";
import { VALIDATION_MESSAGES, VALIDATION_LIMITS } from "../constants";
import { requiredString } from "../utils/validationUtils";

export const bookingAssignDriverSchema = (isReassign: boolean) =>
  z.object({
    driver_ulid: requiredString(VALIDATION_MESSAGES.REQUIRED.DRIVER_ID),
    vehicle_ulid: requiredString(VALIDATION_MESSAGES.REQUIRED.VEHICLE_ID),
    delivery_date: requiredString(VALIDATION_MESSAGES.REQUIRED.DELIVERY_DATE),
    shipping_window_ulid: requiredString(VALIDATION_MESSAGES.REQUIRED.SHIPPING_WINDOW),
    ...(isReassign
      ? {
        notes: requiredString(VALIDATION_MESSAGES.REQUIRED.NOTES)
          .max(
            VALIDATION_LIMITS.NOTES_MAX_LENGTH,
            VALIDATION_MESSAGES.LENGTH.NOTES_MAX
          ),
      }
      : {
        notes: z
          .string()
          .max(
            VALIDATION_LIMITS.NOTES_MAX_LENGTH,
            VALIDATION_MESSAGES.LENGTH.NOTES_MAX
          ),
      }),
  });

export const shipmentActivitySchema = z.object({
  destination_ulid: requiredString(VALIDATION_MESSAGES.REQUIRED.DESTINATION),
  activity_subtype: requiredString(VALIDATION_MESSAGES.REQUIRED.TRANSIT_TYPE),
  notes: z
    .string()
    .max(
      VALIDATION_LIMITS.NOTES_MAX_LENGTH,
      VALIDATION_MESSAGES.LENGTH.NOTES_MAX
    )
    .optional(),
  attachment_ulids: z
    .array(z.string())
    .max(
      VALIDATION_LIMITS.ATTACHMENT_MAX,
      VALIDATION_MESSAGES.LENGTH.ATTACHMENT_MAX
    )
    .min(1, VALIDATION_MESSAGES.REQUIRED.ATTACHMENT),
});

export const shipmentProofSchema = shipmentActivitySchema
  .extend({
    conditions: z
      .array(z.string())
      .nonempty(VALIDATION_MESSAGES.REQUIRED.CONDITION),
  })
  .omit({
    activity_subtype: true,
  });

export const arrivalClaimSchema = shipmentActivitySchema.omit({
  activity_subtype: true,
});

export const bookingDraftConfirmSchema = z.object({
  driver_ulid: requiredString(VALIDATION_MESSAGES.REQUIRED.DRIVER_ID),
  vehicle_ulid: requiredString(VALIDATION_MESSAGES.REQUIRED.VEHICLE_ID),
  delivery_date: requiredString(VALIDATION_MESSAGES.REQUIRED.DELIVERY_DATE),
  shipping_window_ulid: requiredString(VALIDATION_MESSAGES.REQUIRED.SHIPPING_WINDOW),
});
